import * as React from 'react'
import { useState, useEffect, useRef } from 'react'
import {
  Grid,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Radio,
  Button,
  Checkbox,
  RadioGroup,
  IconButton,
  Box,
} from '@mui/material'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabContext from '@mui/lab/TabContext'
import TabPanel from '@mui/lab/TabPanel'
import SignatureCanvas from 'react-signature-canvas'
import { createCanvasStamp, createCanvasSignature } from '@util/signature-stamp'
import { showSnackbar } from '@context/SnackbarContext'
import ApprovalOutlinedIcon from '@mui/icons-material/ApprovalOutlined';
import { OtherHouses } from '@mui/icons-material'




const StampSign = ({userName, callback}) => {
  const fonts = ['EliceDXNeolli', 'HakgyoansimNamu', 'Puzzle', 'Allim']
  const options = {
    width: 70,
    height: 70,
  }

  const [urls, set_urls] = useState([])

  const genStamps = async () => {
    const newUrls = []
    for (let i = 0; i < fonts.length; i++) {

      const url = await createCanvasStamp(userName, fonts[i], options)
      newUrls.push(url)
    }
    set_urls(newUrls)
  }

  useEffect(() => {
    genStamps()
  }, [])

  return (
    <Grid container spacing={1}>
      {urls.map((url, idx) => (
        <Grid item xs={6} key={idx} >
          <img
            style={{cursor:'pointer'}}
            src={url}
            onClick={() => {
              callback(url)
            }}
          />
        </Grid>
      ))}
    </Grid>
  )
}

const BuiltSign = ({userName, callback}) => {
  const fonts = ['NanumPen', 'KCCKimhun', 'KCCUnyoung', 'KCCKimhwanki']
  const options = {
    width: 70 + (userName.length - 3) * 20
    // width: 200
  }
  const [urls, set_urls] = useState([])
  
  const genStamps = async () => {
    const newUrls = []
    for (let i = 0; i < fonts.length; i++) {
      const url = await createCanvasSignature(userName, fonts[i], options)
      newUrls.push(url)
    }
    set_urls(newUrls)
  }

  useEffect(() => {
    genStamps()
  }, [])

  return (
    <Grid container spacing={1}>
      {urls.map((url, idx) => (
        <Grid item xs={6} key={idx} >
          <img
            style={{cursor:'pointer'}}
            src={url}
            onClick={() => {
              callback(url)
            }}
          />
        </Grid>
      ))}
    </Grid>
  )
}

const HandSign = ({callback}) => {
  const width = 300
  const height = 150
  console.log('rendering.........')
  const sigRef = useRef(null)
  const theme = useTheme()
  useEffect(() => {
    if (sigRef.current) {
      const timeoutId = setTimeout(() => {
        const canvas = sigRef.current?.getCanvas()
        if (canvas) {
            canvas.width = width
            canvas.height = height
        }
      }, 50) 

      return () => clearTimeout(timeoutId)
    }
  }, [callback])

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Grid container spacing={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Grid item xs={12}>
            서명란
          </Grid>
          <Grid item xs={12} md={8}>
            <SignatureCanvas
              clearOnResize={false}
              ref={sigRef}
              canvasProps={{
                style: { backgroundColor: '#fafafa', border: '1px solid silver', width: width, height: height },
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Button
                  fullWidth
                  onClick={(e) => {
                    sigRef.current?.clear()
                  }}>
                  서명지우기
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  fullWidth
                  onClick={(e) => {
                    if (sigRef.current.isEmpty()) {
                      showSnackbar('서명란에 사인해 주세요.', theme.palette.warning.dark)
                      return
                    }
                    const url = sigRef.current.getTrimmedCanvas().toDataURL('image/png')
                    callback(url)
                  }}>
                  서명사용
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}


const MemoizedStampSign = React.memo(StampSign)
const MemoizedBuiltSign= React.memo(BuiltSign)
const MemoizedHandSign = React.memo(HandSign)

const Signer = ({ userName, callback }) => {
  
  const theme = useTheme()
  const tabs = [
    { label: '도장선택', value: 0 },
    { label: '서명선택', value: 1 },
    { label: '서명하기', value: 2 },
  ]
  const [picSign, set_picSign] = useState('')

  const [tabValue, set_tabValue] = useState(0)

  const handleTabChange = (event, newValue) => {
    set_tabValue(newValue)
  }

  const handleSignature = React.useCallback((url) => {
    // Note: The original HandSign code doesn't use the prop, 
    // but the intention was likely to call back with the signature URL.
    // set_picSign(url) // Or something similar
    set_picSign(url)
    if(callback) {
      callback(url)
    }
  }, [set_picSign])


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TabContext value={tabValue}>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                position: 'sticky',
                top: 0,
                backgroundColor: '#fff',
                overflowX: 'auto',
              }}>
              <TabList
                onChange={handleTabChange}
                aria-label='lab API tabs example'
                scrollButtons='auto'
                variant='scrollable'>
                {tabs.map((tab, idx) => (
                  <Tab key={idx} label={tab.label} value={tab.value} />
                ))}
              </TabList>
            </Box>
            {/* {tabs.map((tab, idx) => (
              <TabPanel key={idx} value={tab.value} hidden={tabValue !== tab.value}>
                {tab.value === 0 ? (
                  <StampSign />
                ) : tabValue === 1 ? (
                  <BuiltSign />
                ) : tabValue === 2 ? (
                  <MemoizedHandSign callback={handleSignature}/>
                ) : null}
              </TabPanel>
            ))} */}

            <Box sx={{minHeight:100, padding:'10px'}}>
              <Box sx={{ display: tabValue === 0 ? 'block' : 'none' }}>
                <MemoizedStampSign userName={userName} callback={handleSignature} />
              </Box>

              <Box sx={{ display: tabValue === 1 ? 'block' : 'none' }}>
                <MemoizedBuiltSign userName={userName} callback={handleSignature} />
              </Box>

              <Box sx={{ display: tabValue === 2 ? 'block' : 'none' }}>
                <MemoizedHandSign callback={handleSignature} />
              </Box>
            </Box>
            
            
          </TabContext>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>

        <Grid item xs={12} style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
          <ApprovalOutlinedIcon/>
          <Typography>사용할 도장 또는 서명</Typography>
        </Grid>
        <Grid item xs={12} style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
          {picSign.length > 0 ? <img src={picSign} /> : <Typography variant='body2' color={theme.palette.secondary.main}>도장/서명을 선택 또는 서명하기 해 주세요.</Typography>}
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>
    </>
  )
}

export default Signer
